<template>
  <router-view></router-view>
</template>
<script>
import i18n from '@/i18n';

const component = {
  name: 'root',
  beforeRouteEnter(to, from, next) {
    const lang = to.params.lang;
    if (!['de', 'en'].includes(lang)) {
      return next('/');
    }

    if (i18n.locale !== lang) {
      i18n.locale = lang;
    }
    window.$cookies.set('locale', lang);

    return next();
  },
  beforeRouteUpdate(to, from, next) {
    return component.beforeRouteEnter(to, from, next);
  }
};
export default component;
</script>